import filter from "lodash/filter";
import sortedUniq from "lodash/sortedUniq";
import { eachMinuteOfInterval, parse, format } from "date-fns";
const timeFormat = "hh:mm a";

export const getTimeSlotsByDay = (day, slots) => {
	const results = filter(slots, { day });

	let times = [];
	results.forEach((slot) => {
		const list = eachMinuteOfInterval(
			{
				start: parse(slot.startTime, "hh:mm a", new Date()),
				end: parse(slot.endTime, "hh:mm a", new Date()),
			},
			{ step: slot.duration }
		);
		times = times.concat(list.map((time) => ({ time, slotId: slot.id })));
	});

	times = sortedUniq(times, (time) => time.time);
	const timeSlots = [];
	for (let i = 0; i < times.length; i++) {
		const slot1 = times[i];
		const start = format(slot1.time, timeFormat);
		const nextIndex = i + 1;
		if (nextIndex < times.length) {
			const slot2 = times[nextIndex];
			const end = format(slot2.time, timeFormat);
			timeSlots.push({
				start,
				end,
				id: `${start}_${end}`,
				slotId: slot1.slotId,
			});
		}
	}
	return timeSlots;
};
